import { useEffect, useState } from 'react';
import { brandName, navLinks } from '@/mocks/homeData';

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [active, setActive] = useState('hot');

  useEffect(() => {
    const sections = navLinks
      .map((link) => document.getElementById(link.id))
      .filter((el): el is HTMLElement => Boolean(el));

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActive(entry.target.id);
          }
        });
      },
      { rootMargin: '-45% 0px -50% 0px', threshold: 0 },
    );

    sections.forEach((section) => observer.observe(section));
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  const today = new Date();
  const dateText = `${today.getFullYear()}年${today.getMonth() + 1}月${today.getDate()}日`;

  return (
    <header className="sticky top-0 z-50">
      <div className="bg-primary-600 text-background-50">
        <div className="mx-auto flex h-9 max-w-[1400px] items-center justify-between gap-4 px-4 md:px-6">
          <p className="flex items-center gap-2 text-xs">
            <i className="ri-flashlight-fill text-accent-300" aria-hidden="true" />
            <span className="whitespace-nowrap">独家速递 · 抢先看 · 第一弹持续更新</span>
          </p>
          <div className="hidden items-center gap-4 text-xs md:flex">
            <span className="whitespace-nowrap opacity-90">{dateText}</span>
            <span className="h-3 w-px bg-background-50/30" />
            <a
              href="#contact"
              className="cursor-pointer whitespace-nowrap transition-opacity hover:opacity-75"
            >
              提供线索
            </a>
          </div>
        </div>
      </div>

      <div className="border-b border-background-200 bg-background-50/95 backdrop-blur">
        <div className="mx-auto flex h-16 max-w-[1400px] items-center justify-between gap-6 px-4 md:h-[72px] md:px-6">
          <a href="#top" className="flex cursor-pointer items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-xl text-background-50">
              <i className="ri-flashlight-fill" aria-hidden="true" />
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-bold tracking-tight text-foreground-950 md:text-xl">
                {brandName}
              </span>
              <span className="mt-1 hidden text-[11px] tracking-[0.2em] text-secondary-600 sm:block">
                REVEAL · LIVE
              </span>
            </span>
          </a>

          <nav aria-label="主导航" className="hidden items-center gap-1 lg:flex">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                className={`cursor-pointer whitespace-nowrap rounded-md px-3 py-2 text-sm transition-colors ${
                  active === link.id
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100 hover:text-primary-600'
                }`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#contact"
              className="hidden cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
            >
              <i className="ri-notification-3-line" aria-hidden="true" />
              订阅速递
            </a>
            <button
              type="button"
              onClick={() => setMenuOpen((prev) => !prev)}
              aria-label={menuOpen ? '关闭菜单' : '打开菜单'}
              aria-expanded={menuOpen}
              className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300 text-xl text-foreground-800 transition-colors hover:bg-background-100 lg:hidden"
            >
              <i className={menuOpen ? 'ri-close-line' : 'ri-menu-line'} aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="border-b border-background-200 bg-background-50 lg:hidden">
          <nav aria-label="移动端导航" className="mx-auto max-w-[1400px] px-4 py-4 md:px-6">
            <div className="grid grid-cols-2 gap-2">
              {navLinks.map((link) => (
                <a
                  key={link.id}
                  href={`#${link.id}`}
                  onClick={() => setMenuOpen(false)}
                  className="cursor-pointer rounded-md border border-background-200 bg-background-100 px-4 py-3 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
                >
                  {link.label}
                </a>
              ))}
            </div>
            <a
              href="#contact"
              onClick={() => setMenuOpen(false)}
              className="mt-3 flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-sm text-background-50"
            >
              <i className="ri-notification-3-line" aria-hidden="true" />
              订阅热点速递
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}